// @flow

import type { Node } from 'react';
import { connect } from 'react-redux';
import type { State as Viewer } from 'app/common/redux/reducers/viewer';
import type { State } from 'app/common/redux/reducers/types';

const ConnectViewer = ({ children, viewer }: { children: (Viewer) => Node, viewer: Viewer }) =>
  children(viewer);
const mapStateToProps = ({ viewer }: State) => ({ viewer });

// $FlowFixMe: new errors found from flow 0.96 upgrade
export default connect(mapStateToProps)(ConnectViewer);
